<template>
    <modal ref="modal" size="lg" :has-footer="false">
        <span slot="title">Preview Public Campaign</span>
        <span slot="footer"></span>
        <div class="row">
            <div class="col-1 align-self-center">
                <button class="btn btn-light" @click="prev" :disabled="prevStep === undefined">
                    <i class="fas fa-angle-left fa-3x"></i>
                </button>
            </div>
            <div class="col">
                <rate
                    v-if="step === 'rate'"
                    :image="campaign.image"
                    :type="campaign.type"
                    :question="ratingMessage"
                    :submitText="submitButtonRating">
                </rate>
                <feedback-review v-if="step === 'feeback-before'" :image="campaign.image"
                    text="Please tell us why you chose __">
                </feedback-review>
                <share
                    v-if="step === 'share'"
                    :image="campaign.image"
                    :sites="campaign.review_sites"
                    :question="shareMessage"
                    :allowPrivateFeedback="campaign.allow_private_feedback">
                </share>
                <feedback-review
                    v-if="step === 'feedback'"
                    mode="noAccount"
                    :image="campaign.image"
                    :text="feedbackMessage"
                    :textSubmit="submitButtonFeedback"
                    :textBack="backButtonFeedback">
                </feedback-review>
                <thank-you v-if="step === 'thank-you'" :image="campaign.image" :text="thanksMessage"></thank-you>
            </div>
            <div class="col-1 align-self-center">
                <button class="btn btn-light" @click="next" :disabled="nextStep === undefined">
                    <i class="fas fa-angle-right fa-3x"></i>
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    props: ['campaign'],

    data() {
        const types = {
            PUBLIC: 'public',
            CX: 'cx',
            NPS: 'nps',
        };
        return {
            step: this.campaign.type === types.PUBLIC ? 'share' : 'rate',
            types,
        };
    },

    computed: {
        steps() {
            if (this.campaign.type === this.types.PUBLIC) {
                return ['share', 'feedback', 'thank-you'];
            }
            return ['rate', 'feeback-before', 'share', 'feedback', 'thank-you'];
        },
        nextStep() {
            let index = this.steps.indexOf(this.step) + 1;
            if (index >= this.steps.length) {
                return undefined;
            }
            return index;
        },
        prevStep() {
            let index = this.steps.indexOf(this.step) - 1;
            if (index < 0) {
                return undefined;
            }
            return index;
        },

        settings() { return this.campaign.settings; },

        ratingMessage() { return (this.settings && this.settings.rating_message) || 'How would you rate your experience with us?'; },

        thanksMessage() { return (this.settings && this.settings.thank_you_message) || 'Thank You!'; },

        feedbackMessage() { return (this.settings && this.settings.feedback_message) || 'Please tell us more about your experience'; },

        shareMessage() { return (this.settings && this.settings.share_message) || 'Please select a site below to leave us a review'; },

        submitButtonFeedback() { return (this.settings && this.settings.submit_button_feedback) || 'Submit'; },

        submitButtonRating() { return (this.settings && this.settings.submit_button_rating) || 'Submit'; },

        backButtonFeedback() { return (this.settings && this.settings.back_button_feedback) || 'Back'; },
    },

    methods: {
        open() {
            this.$refs.modal.open();
        },

        next() {
            this.step = this.steps[this.nextStep];
        },

        prev() {
            this.step = this.steps[this.prevStep];
        },
    },
};
</script>
